import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ChennaiLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `https://api.livestockify.com/api/chennai/login`,
        { email, password, userType: "Organization" },
      );

      const { token, userId, email: userEmail, userRole } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("User_Id", userId);
      localStorage.setItem("email", userEmail);
      localStorage.setItem("userRole", userRole);

      if (userRole?.toLowerCase() === "admin") {
        navigate("/chennai/admin/dashboard");
      } else if (userRole?.toLowerCase() === "client") {
        navigate("/chennai-user/dashboard");
      } else {
        alert("Unauthorized role.");
      }
    } catch (error) {
      alert(
        error.response?.data?.message ||
          "Login failed. Please check your credentials.",
      );
      localStorage.clear();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex font-sans">
      <div
        className="hidden md:flex md:w-1/2 bg-contain bg-center bg-no-repeat relative"
        style={{
          backgroundImage:
            "url('http://res.cloudinary.com/dt8emxboh/image/upload/v1766131361/fyaovnlokqsxvbn0j5l8.jpg')",
        }}
      >
        {/* Overlay Content */}

        <div className="absolute inset-0 bg-white/60 flex flex-col justify-center items-center px-10 text-center">
          <img
            src="http://res.cloudinary.com/dt8emxboh/image/upload/v1762323243/zwibh7dibwkuwxhblqkc.png"
            alt="AVRIS"
            className="w-100 mb-20"
          />

          <h2 className="text-3xl font-bold text-black max-w-md">
            <span className="block">Access real-time insights and</span>
            <span className="block">centralized management</span>
          </h2>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex flex-col justify-center px-6 sm:px-10 md:px-16 bg-white">
        {/* Mobile & Tablet Logo */}
        <div className="flex justify-center mb-8 md:hidden">
          <img
            src="http://res.cloudinary.com/dt8emxboh/image/upload/v1762323243/zwibh7dibwkuwxhblqkc.png"
            alt="AVRIS"
            className="w-48 sm:w-56 object-contain"
          />
        </div>

        <h1 className="text-[#34C759] text-4xl sm:text-5xl font-semibold mb-10 text-center md:text-left">
          Login
        </h1>

        <form
          onSubmit={handleSubmit}
          className="max-w-md w-full mx-auto md:mx-0"
        >
          {/* Email */}
          <div className="mb-5">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your Email ID"
              required
              className="w-full px-5 py-5 border border-gray-300 rounded-lg 
              placeholder-gray-500 placeholder:font-bold focus:outline-none focus:border-[#2FA84F]"
            />
          </div>

          {/* Password */}
          <div className="mb-8">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your Password"
              required
              className="w-full px-5 py-5 border border-gray-300 rounded-lg 
              placeholder-gray-500 placeholder:font-bold focus:outline-none focus:border-[#2FA84F]"
            />
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-lg text-white font-bold text-xl transition ${
              loading
                ? "bg-[#2FA84F]/70 cursor-not-allowed"
                : "bg-[#2FA84F] hover:bg-[#269943]"
            }`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="fixed bottom-4 right-4 z-50">
          <div className="text-center">
            <p className="text-xs text-black mb-1">Powered By</p>
            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1761305001/emocm50thu3idxar2qe4.png"
              alt="KuppiSmart"
              className="w-32 md:w-40 lg:w-56 xl:w-64"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChennaiLogin;
